import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "../../../contexts/AuthContext";

import { t } from "../../../i18n";
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuthContext();
  const location = useLocation();

  if (isLoading) {
    // Show loading state while checking authentication
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-brand-600 text-lg">{t("جاري التحميل...")}</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    // Remember the page asked for, so signing in lands there (a scanned QR code opens an item directly).
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  // Render the children (protected content) if authenticated
  return children;
};

export default ProtectedRoute;
